import React from "react";
import { MdMail, MdPhoneCallback } from "react-icons/md";
import { useTranslation } from "react-i18next";
import ContactForm from "./ContactForm";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary text-white relative px-[5%]" id="contact">
      <div className="w-full pt-12 sm:pt-16 md:pt-20 maxContainer">
        <div className="flex flex-wrap justify-between gap-8 pb-8">
          <div className="flex flex-col md:w-1/4">
            <p className="pb-5 sm:text-[18px] max-w-[225px] font-semibold">
              {t("footerTranslate.playground_installation_maintainance")}
            </p>
            <ul className="text-[14px] mb-8">
              <li className="pb-1 font-semibold">
                {t("footerTranslate.project_manager")}
              </li>
              <li className="pb-1">Kristupas Naujokas </li>
              <li className="flex items-center gap-2 pb-1">
                <MdPhoneCallback /> <span>+370 640 67376</span>
              </li>
              <li className="flex items-center gap-2 ">
                <MdMail />{" "}
                <a
                  href="mailto:kristupas.naujokas@economus.lt"
                  target="_blank"
                  className="underline transition-transform duration-300 transform hover:text-tertiary"
                  rel="noreferrer"
                >
                  kristupas.naujokas@economus.lt{" "}
                </a>
              </li>
            </ul>

            <ul className="text-[14px]">
              <li className="pb-1 font-semibold">
                {t("footerTranslate.manager")}
              </li>
              <li className="pb-1">Matas Lukosius </li>
              <li className="flex items-center gap-2 pb-1">
                <MdPhoneCallback /> <span>+370 666 84272</span>
              </li>
              <li className="flex items-center gap-2 ">
                <MdMail />{" "}
                <a
                  href="mailto:matas.lukosius@economus.lt"
                  target="_blank"
                  className="underline transition-transform duration-300 transform hover:text-tertiary"
                  rel="noreferrer"
                >
                  matas.lukosius@economus.lt{" "}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:w-1/4 ">
            <p className="pb-5 sm:text-[18px] font-semibold">
              {t("footerTranslate.company")}
            </p>
            <ul className="text-[14px] mb-3">
              <li className="pb-1 font-semibold">UAB Economus</li>
              <li className="pb-2">
                <span className="font-semibold">
                  {t("footerTranslate.address")}
                </span>{" "}
                Kuosų g.9-108,
                <br /> Vilnius, LT-10312{" "}
              </li>
            </ul>

            <ul className="text-[14px] mb-3">
              <li className="pb-1 font-semibold">
                {t("footerTranslate.office_address")}
              </li>
              <li className="pb-2">
                Old Ukmergės kel.4,
                <br /> Užubaliai, LT-14302 Vilnius.
              </li>
            </ul>

            <ul className=" text-[14px] mb-3">
              <li className="pb-1 font-semibold">
                <span className="font-semibold">
                  {t("footerTranslate.company_code")}
                </span>{" "}
                300582646
              </li>
              <li className="pb-2">
                <span className="font-semibold">
                  {t("footerTranslate.vat_number")}
                </span>{" "}
                LT100002704415.
              </li>
            </ul>
          </div>

          <div className="md:w-1/4">
            <p className="pb-5 sm:text-[18px] font-semibold">
              {t("footerTranslate.director")}
            </p>
            <ul className=" text-[14px] mb-8">
              <li className="pb-2">Mindaugas Jokimčius </li>
              {/* <li className="flex items-center gap-2 ">
                <MdMail />
                <a
                  href="mailto:mindaugas.jokimcius@economus.lt"
                  target="_blank"
                  className="underline transition-transform duration-300 transform hover:text-tertiary"
                  rel="noreferrer"
                >
                  mindaugas.jokimcius@economus.lt{" "}
                </a>
              </li> */}
            </ul>

            <div className="text-[14px]">
              <p className="pb-2 max-w-[225px] font-semibold">
                {t("footerTranslate.report_defect_playground")}
              </p>
              <ul className="mb-3 ">
                <li>
                  {t("footerTranslate.or_to_uab")}{" "}
                  <div className="flex items-center gap-2">
                    <MdMail />{" "}
                    <a
                      href="mailto:info@economus.lt"
                      target="_blank"
                      className="underline transition-transform duration-300 transform hover:text-tertiary"
                      rel="noreferrer"
                    >
                      info@economus.lt{" "}
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <ContactForm />

        <div className="w-full pt-5 pb-12 border-t sm:pb-10">
          <div className="flex items-center justify-between gap-4">
            <span className="text-[14px] text-center">
              © 2025 Economus. {t("footerTranslate.all_right_reserved")}
            </span>
            <span className="text-[14px] text-center">
              {t("footerTranslate.terms_condition")}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
